import { PrjTitle, PrjText, PrjGif, PrjCol } from "../../../../src/data/projects/mdxComponents";
import * as React from 'react';
export default {
  PrjTitle,
  PrjText,
  PrjGif,
  PrjCol,
  React
};